import React from 'react';
import { Container } from '@/components/layout';
import Discussion from '@/types/Discussions';
import PageLayout from '@/widgets/PageLayout';
import { SectionByName } from '@/domains/blogs/pages/BlogPostPage/SectionByName/SectionByName';
import { ContentType } from '@/common/constants/ContentTypes';
import { SectionByContent } from '../blogs/constants/SectionByContent';
import { GridContainer } from './styles';

interface DiscussionPageProps {
  discussion: Discussion;
}

function DiscussionPage({ discussion }: DiscussionPageProps): JSX.Element {
  const layoutSections = SectionByContent.discussion.default;

  return (
    <PageLayout>
      <Container>
        <GridContainer>
          {layoutSections.map((section) => (
            <SectionByName
              key={section}
              sectionName={section}
              contentType={ContentType.DISCUSSIONS}
              content={discussion}
            />
          ))}
        </GridContainer>
      </Container>
    </PageLayout>
  );
}

export default DiscussionPage;
